import { reset } from 'src/store'

const loggedInStates = () => {
  return [
    'tips'
  ]
}

const defaultStates = () => {
  return {
    tips: []
  }
}

export default {
  namespaced: true,
  state: defaultStates(),
  mutations: {
    reset (state) {
      reset(state, loggedInStates(), defaultStates())
    },
    setTips (state, tips = []) {
      if (!Array.isArray(tips)) {
        tips = [tips]
      }
      tips = tips.filter(item => !state.tips.includes(item))
      state.tips.push(...tips)
    }
  },
  getters: {
    hasDismissedTip: state => (key) => {
      return state.tips.includes(key)
    }
  }
}
